import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=b3387658&scoped=true"
import script from "./FileSelect.vue?vue&type=script&lang=js"
export * from "./FileSelect.vue?vue&type=script&lang=js"
import style0 from "./FileSelect.vue?vue&type=style&index=0&id=b3387658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3387658",
  null
  
)

export default component.exports